export default __webpack_public_path__ + "static/bear-app-b91752bfa486f1c537b2e0638deeb0c9.png";